import type { FilterEvaluator } from './FilterEvaluator';

export class MatchAllEvaluator<RecordType> implements FilterEvaluator<RecordType> {
  public static readonly INSTANCE: FilterEvaluator<unknown> = new MatchAllEvaluator<unknown>();

  evaluate(_: RecordType): boolean {
    return true;
  }
}
